<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Prospecções</h1>
    <div class="mb-6 flex justify-between items-center">
      <text-input v-model="form.search" class="w-full max-w-md mr-4" label="Cliente" />
      <select-input v-model="form.status" class="w-full max-w-md mr-4" label="Situação">
        <option value="T" selected>Todas</option>
        <option v-for="s in Object.keys(status)" :key="s" :value="s">{{ status[s] }}</option>
      </select-input>
      <select-input v-model="form.reacao" class="w-full max-w-md mr-4" label="Reação">
        <option value="T" selected>Todas</option>
        <option v-for="r in Object.keys(reacoes)" :key="r" :value="r">{{ reacoes[r] }}</option>
      </select-input>
    </div>
    <div class="mb-2 flex justify-between items-center">
      <text-input v-model="form.dtProspeccao" type="date" value-type="YYYY-MM-DD" range class="w-full max-w-md mr-4" label="Período de" />
      <select-input v-model="form.solicitouOrcamento" class="w-full max-w-md mr-4" label="S. Orçamento">
        <option value="T" selected>Todos</option>
        <option value="S">Sim</option>
        <option value="N">Não</option>
      </select-input>
      <SelectMulti :key="form.vendedor" v-model="form.vendedor" :options="vendedores" placeholder="pesquise vendedor" :reduce="row => row.idPessoa" track-by="razaoSocial" class="w-full max-w-md mr-4" label="Vendedor" label-field="razaoSocial" />
    </div>
    <div class="mb-2 flex justify-between items-center">
      <text-input v-model="form.dtProximaVisita" type="date" class="w-full max-w-md mr-4" label="Próxima visita" />
      <SelectMulti :value="canais.find(c => c.idClienteOrigem == form.idClienteOrigem)" :options="canais" placeholder="canal" track-by="idClienteOrigem" class="w-full max-w-md mr-4" label="Canal" label-field="descricao" @input="opt => form.idClienteOrigem = opt.idClienteOrigem" />
      <SelectMulti :value="atividades.find(c => c.idEmpresaAtividade == form.idEmpresaAtividade)" :options="atividades" placeholder="segmento" :reduce="row => row.idEmpresaAtividade" track-by="idEmpresaAtividade" class="w-full max-w-md mr-4" label="Segmento" label-field="descricao" @input="opt => form.idEmpresaAtividade = opt ? opt.idEmpresaAtividade : null" />
    </div>
    <div class="mb-2 flex justify-between items-center">
      <select-input v-model="form.usaSistema" class="w-full max-w-md mr-4" label="Usa algum Sistema" @input="() => form.idSistemaConcorrente = null ">
        <option value="T" selected>Todos</option>
        <option value="S">Sim</option>
        <option value="N">Não</option>
      </select-input>
      <SelectMulti :disabled="form.usaSistema != 'S'" :value="concorrentes.find(c => c.idSistemaConcorrente == form.idSistemaConcorrente)" :options="concorrentes" placeholder="qual sistema?" track-by="idSistemaConcorrente" class="w-full max-w-md mr-4" label="Sistema" label-field="descricao" @input="opt => form.idSistemaConcorrente = opt ? opt.idSistemaConcorrente : null" />
    </div>
    <div class="mb-2 flex space-x-2 items-center">
      <inertia-link class="btn-indigo" :href="route('prospeccoes.create')">
        <span>Criar</span>
      </inertia-link>

      <button v-if="!tabMap" class="btn-indigo flex items-center" @click="tabMap = !tabMap">
        <icon name="map-search" class="h-4 fill-white pr-1" /> <span>Mapa</span>
      </button>
      <button v-else class="btn-indigo flex items-center" @click="tabMap = !tabMap">
        <icon name="list" class="h-4 fill-white pr-1" /> <span>Lista</span>
      </button>
    </div>
    <div class="mb-2 flex space-x-2 items-center">
      <span>Total: <span class="font-bold"> {{ clientes.length }}</span></span>
    </div>

    <div v-if="!tabMap" class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">ID</th>
          <th class="px-6 pt-6 pb-4">Nome</th>
          <th class="px-6 pt-6 pb-4">S. Orçamento</th>
          <th class="px-6 pt-6 pb-4">Situação</th>
          <th class="px-6 pt-6 pb-4">Reação</th>
          <th class="px-6 pt-6 pb-4">Dt. Prospecção</th>
        </tr>
        <tr v-for="cliente in clientes" :key="cliente.idProspeccao" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link :href="route('prospeccoes.edit',cliente.idProspeccao )" class="px-6 py-4 flex items-center focus:text-indigo-500">
              {{ cliente.idProspeccao }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link :href="route('prospeccoes.edit',cliente.idProspeccao )" class="px-6 py-4 flex items-center focus:text-indigo-500">
              {{ cliente.nome }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link :href="route('prospeccoes.edit',cliente.idProspeccao )" class="px-6 py-4 flex items-center focus:text-indigo-500">
              {{ solicitou(cliente) }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link :href="route('prospeccoes.edit',cliente.idProspeccao )" class="px-6 py-4 flex items-center focus:text-indigo-500">
              {{ situacao(cliente) }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link :href="route('prospeccoes.edit',cliente.idProspeccao )" class="px-6 py-4 flex items-center focus:text-indigo-500">
              {{ reacao(cliente) }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link :href="route('prospeccoes.edit',cliente.idProspeccao )" class="px-6 py-4 flex items-center focus:text-indigo-500">
              {{ dtProspeccao(cliente) }}
            </inertia-link>
          </td>

          <td class="border-t w-px">
            <inertia-link :href="route('prospeccoes.edit',cliente.idProspeccao )" class="px-4 flex items-center" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="clientes.length === 0">
          <td class="border-t px-6 py-4" colspan="4">Nenhum Cliente Encontrado.</td>
        </tr>
      </table>
    </div>
    <mapa v-else :prospeccoes="clientes" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import Mapa from './Mapa.vue'
import debounce from 'lodash/debounce'
import mapValues from 'lodash/mapValues'
import TextInput from '../../Shared/TextInput.vue'
import SelectMulti from '../../Shared/SelectMulti.vue'
import { DateTime } from 'luxon'
import SelectInput from '../../Shared/SelectInput.vue'
import { status, reacoes } from '@/Utils/helpers'
export default {
  metaInfo: { title: 'Prospecções' },
  components: {
    Icon,
    TextInput,
    SelectInput,
    SelectMulti,
    Mapa,
  },
  layout: Layout,
  props: {
    filters: Object,
    clientes: Array,
    vendedores: Array,
    cidades: Array,
    canais: Array,
    atividades: Array,
    concorrentes: Array,
  },
  data() {
    return {
      tabMap: false,
      options: [],
      selectedCidade:'',
      status,
      reacoes,
      form: {
        search: this.filters.search,
        status: this.filters.status,
        cidade: this.filters.cidade,
        reacao: this.filters.reacao,
        idClienteOrigem: this.filters.idClienteOrigem,
        idEmpresaAtividade: this.filters.idEmpresaAtividade,
        dtProspeccao: this.filters.dtProspeccao,
        solicitouOrcamento: this.filters.solicitouOrcamento,
        vendedor: this.filters.vendedor,
        dtProximaVisita: this.filters.dtProximaVisita,
        usaSistema: this.filters.usaSistema,
        idSistemaConcorrente: this.filters.idSistemaConcorrente,
      },
    }
  },

  watch: {
    form: {
      deep: true,
      handler: debounce(function() {
        this.$inertia.get(this.route('prospeccoes'), pickBy(this.form), { preserveState: true })
      }, 500),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    onSearch(search) {
      if(search.length) {
        this.form.searchCidade=search
      }
    },
    onSelectedCidade(cidade) {
      this.form.cidade=cidade
    },
    getLicencasText(array){
      const modulos = array.map(e =>e.codModulo)
      const uniq = [...new Set(modulos)]
      return uniq.join(',')
    },
    solicitou(model){

      return model.solicitouOrcamento == 'S' ?  'Sim' :  'Não'
    },
    situacao(model){
      return status[model.status] ?? 'Desconhecido'
    },
    reacao(model){
      return reacoes[model.reacao] ?? 'Desconhecido'
    },
    dtProspeccao(model){
      return DateTime.fromSQL(model.dtProspeccao).toFormat('dd/MM/yyyy')
    },
    changeCidade(objCidade){
      this.form.cidade =objCidade.codCidade
    },
  },


}
</script>
